import { render, staticRenderFns } from "./preview-qrcode.vue?vue&type=template&id=2bd67a7a"
import script from "./preview-qrcode.vue?vue&type=script&lang=js"
export * from "./preview-qrcode.vue?vue&type=script&lang=js"
import style0 from "./preview-qrcode.vue?vue&type=style&index=0&id=2bd67a7a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports